import React from "react";

const Heading = ({ headingText }) => {
  return <h1 className="text-BLACK text-center font-extrabold text-[56px] bg-white">{headingText}</h1>;
};

export default Heading;
